import { createFileRoute } from "@tanstack/react-router"

import { breadcrumbJsonLd, buildHead } from "@/core/seo"

import { ProductPage } from "../components/landing"
import { RECEIPT_SCANNER, RECEIPT_SEO } from "../content/products/receipt-scanner"

/** Breadcrumb JSON-LD only: SoftwareApplication/Offer wait for final prices and reviews (copy-products.md). */
export const receiptScannerSeo = () =>
  buildHead({
    ...RECEIPT_SEO,
    path: RECEIPT_SCANNER.path,
    jsonLd: [breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: RECEIPT_SCANNER.name }])],
  })

export const Route = createFileRoute("/_brand-layout/receipt-scanner")({
  head: () => {
    const { meta, links, scripts } = receiptScannerSeo()
    return { meta, links, scripts }
  },
  component: ReceiptScannerPage,
})

export function ReceiptScannerPage() {
  return <ProductPage content={RECEIPT_SCANNER} />
}
